import { createContext, useContext, useReducer, ReactNode, Dispatch } from 'react';
import { Shipment } from '../components/shipment/types';

interface FilterValues {
    searchTerm: string;
    statusFilter: 'all' | string;
}

interface ShipmentState {
    shipments: Shipment[];
    loading: boolean;
    error: any;
    filters: FilterValues;
}

type ShipmentAction =
    | { type: 'FETCH_SHIPMENTS_SUCCESS'; payload: Shipment[] }
    | { type: 'FETCH_SHIPMENTS_FAILURE'; payload: any }
    | { type: 'SET_FILTER'; payload: FilterValues };

const initialState: ShipmentState = {
    shipments: [],
    loading: false,
    error: null,
    filters: {
        searchTerm: '',
        statusFilter: 'all',
    },
};

function shipmentReducer(state: ShipmentState, action: ShipmentAction): ShipmentState {
    switch (action.type) {
        case 'FETCH_SHIPMENTS_SUCCESS':
            return { ...state, shipments: action.payload, loading: false, error: null };
        case 'FETCH_SHIPMENTS_FAILURE':
            return { ...state, loading: false, error: action.payload };
        case 'SET_FILTER':
            return { ...state, filters: action.payload };
        default:
            return state;
    }
}

const ShipmentContext = createContext<{
    state: ShipmentState;
    dispatch: Dispatch<ShipmentAction>;
} | undefined>(undefined);

export const ShipmentProvider = ({ children }: { children: ReactNode }) => {
    const [state, dispatch] = useReducer(shipmentReducer, initialState);
    return (
        <ShipmentContext.Provider value={{ state, dispatch }}>
            {children}
        </ShipmentContext.Provider>
    );
};

export function useShipmentContext() {
    const context = useContext(ShipmentContext);
    if (!context) {
        throw new Error('useShipmentContext must be used within a ShipmentProvider');
    }
    return context;
}
